import { render, staticRenderFns } from "./appDanmakus.vue?vue&type=template&id=53a31998&scoped=true"
import script from "./appDanmakus.vue?vue&type=script&lang=js"
export * from "./appDanmakus.vue?vue&type=script&lang=js"
import style0 from "./appDanmakus.vue?vue&type=style&index=0&id=53a31998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a31998",
  null
  
)

export default component.exports